import React, {useState, useEffect} from 'react';
import CollapseButton from '../../../../utilities/CollapseButton/CollapseButton';
import {setPriceCyclesDescription, checkSectionValid} from './HelperFunctions';

const BlockFrame = ({data, context, blockInfo}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [blockInfoState, setBlockInfoState] = useState(<div />);
  let showComponent = checkSectionValid(blockInfo);
  useEffect(() => {
    if (showComponent) setBlockInfoState(optionalServices, setBlockInfoState);
  }, [optionalServices.services]);
  const cardTitle = data.optionalServicesTopic.value === '' ? 'השירותים שלך' : data.optionalServicesTopic.value;

  return (
    showComponent && (
      <div className='block-frame p-2'>
        <CollapseButton cardTitle={cardTitle} SetIsOpen={SetIsOpen} isOpen={isOpen} />
        {isOpen && (
          <div className='block-frame__container'>
            <div className='equipment-summary'></div>
          </div>
        )}
      </div>
    )
  );
};

export default BlockFrame;
